export const regexByPrecision = (precision) => {
  return new RegExp(`^([0]{1}|([1-9]{1}\\d*))(?:\\.\\d{0,${precision}})?$`);
};
